import * as Constants from './constants'

export const productsListRequest = function productsListRequest(formData) {
  return {
    type: Constants.PRODUCTS_LIST_REQUESTING,
    payload: formData
  }
}

export const productsListSuccess = function productsListSuccess(data) {
  return {
    type: Constants.PRODUCTS_LIST_SUCCESS,
    data
  }
}

export const productsListError = function productsListError(error) {
  return {
    type: Constants.PRODUCTS_LIST_ERROR,
    error
  }
}

export const productsDetailRequest = function productsDetailRequest(formData) {
  return {
    type: Constants.PRODUCTS_DETAIL_REQUESTING,
    payload: formData
  }
}

export const productsDetailSuccess = function productsDetailSuccess(data) {
  return {
    type: Constants.PRODUCTS_DETAIL_SUCCESS,
    data
  }
}

export const productsDetailError = function productsDetailError(error) {
  return {
    type: Constants.PRODUCTS_DETAIL_ERROR,
    error
  }
}

export const productsUpdateRequest = (formData, callback) => {
  return {
    type: Constants.PRODUCTS_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const productsUpdateSuccess = function productsUpdateSuccess(response) {
  return {
    type: Constants.PRODUCTS_UPDATE_SUCCESS,
    payload: response
  }
}

export const productsUpdateError = function productsUpdateError(error) {
  return {
    type: Constants.PRODUCTS_UPDATE_ERROR,
    error
  }
}

export const productsRemoveRequest = (formData, callback) => {
  return {
    type: Constants.PRODUCTS_REMOVE_REQUESTING,
    payload: formData,
    callback
  }
}

export const productsRemoveSuccess = function productsRemoveSuccess(response) {
  return {
    type: Constants.PRODUCTS_REMOVE_SUCCESS,
    payload: response
  }
}

export const productsRemoveError = function productsRemoveError(error) {
  return {
    type: Constants.PRODUCTS_REMOVE_ERROR,
    error
  }
}

export const productsExportXlsRequest = function productsExportXlsRequest(formData, callback) {
  return {
    type: Constants.PRODUCTS_EXPORT_XLS_REQUESTING,
    formData,
    callback
  }
}

export const productsExportXlsSuccess = function productsExportXlsSuccess(data) {
  return {
    type: Constants.PRODUCTS_EXPORT_XLS_SUCCESS,
    data
  }
}

export const productsExportXlsError = function productsExportXlsError(error) {
  return {
    type: Constants.PRODUCTS_EXPORT_XLS_ERROR,
    error
  }
}


// WEBPACK FOOTER //
// ./src/views/Products/actions.js